// URL for the API
export const baseURL = "https://api-next.martvanweeghel.nl"; //https://api-next.martvanweeghel.nl

// Routes for the API
export const apiPath = {
  members: "/members",
  events: "/events",
  images: "/images",
  contacts: "/contacts",
  youtubeVideos: "/youtube",
};
